import styled from 'styled-components';

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 900px;
`;

export const HeaderContainer = styled.div`
  padding: 32px;
  width: 100%;
  text-align: center;
`;

export const HeaderIcon = styled.img`
  width: 100%;
  max-width: 300px;
`;

export const TabletContainer = styled.div``;
